<template>
  <div
    :key="collectionSelectedItems"
    class="display-collection-items"
  >
    <div
      v-for="item in collectionSelectedItems"
      :key="item.id"
    >
      <div
        v-show="showCollectionSearchDisplayType === 'showCollectionGrid' || display === 'queue'"
        :id="'addItem' + item.id"
        ref="grid"
        class="marketing-item-container c"
      >
        <SelectionMarker
          v-show="inMultiSelectionMode && display === 'full'"
          ref="selectionMarker"
        />
        <div
          :id="'removeItem' + item.id"
          class="delete circle"
          @click="handleRemoveItems(item)"
          @mouseover="handleHover(item)"
          @mouseleave="handleHoverLeave(item)"
        >
          <div class="icon-size-del">
            <v-img
              :src="require('@/assets/svg/SVG/x.svg')"
              class="list-icon"
            />
          </div>
        </div>  
        <div class="image">
          <v-img
            :src="item.imageUri"
            max-width="200"
            max-height="50"
            alt="Download"
          />
        </div> 
        <div class="label">
          {{ item.name }}
        </div>
      </div>
      <div
        v-show="showCollectionSearchDisplayType === 'showCollectionList' || display === 'full'"
        :id="'addItem' + item.id"
        ref="list"
        class="marketing-item-list-container c"
        @mouseover="handleHover(item)"
        @mouseleave="handleHoverLeave(item)"
      >
        <div class="left-side">
          <SelectionMarker
            v-show="inMultiSelectionMode && display === 'full'"
            ref="selectionMarkerList"
            class="selectionMarkerList"
          />
          <div class="image-list">
            <img
              :src="item.imageUri"
              alt="image"
              class="list-image"
            >
          </div>
          <div class="label">
            {{ item.name }}
          </div>
        </div>
        <div>
          <div
            :id="'removeItem' + item.id"
            class="delete circle"
            @click="handleRemoveItems(item)"
            @mouseover="handleHover(item)"
            @mouseleave="handleHoverLeave(item)"
          >
            <div class="icon-size-del">
              <v-img
                :src="require('@/assets/svg/SVG/x.svg')"
                class="list-icon"
              />
            </div>
          </div> 
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useRMTStore } from '@/store/RMTStore';
import { gsap } from 'gsap';
import SelectionMarker from '@/components/libraries/search/marketingItem/SelectionMarker';
import { mapStores } from 'pinia';

export default {
  components: {
		SelectionMarker
	},
  props: [
    'display'
  ],
  computed: {
    ...mapStores(useRMTStore),
    inMultiSelectionMode () {
      return this.RMTStore.getInMultiSelectionMode;
    },
    collectionSelectedItems () {
      return this.RMTStore.getCollectionSelectedItems;
    },
    showCollectionSearchDisplayType () {
      return this.RMTStore.getShowCollectionSearchDisplayType;
    }
  },
  mounted () {
    this.RMTStore.displayCollectionItems.forEach((item) => {
      const itemId = '#addItem' + item.id;
      gsap.to(itemId, {
        border: '1px solid black'
      });
    });
  },
  methods: {
    handleRemoveItems (item) {
      const removeItemId = 'addItem' + item.id;
      const removeItem = this.RMTStore.createdCollectionItems.filter(function (element) {
        return element.id != item.id;
      });
      const removeId = this.RMTStore.createdCollectionId.filter(function (element) {
        return element != item.id;
      });
      const itemId = '#item' + item.id;
      gsap.to(itemId, {
        backgroundColor: '#ffffff',
        border: 'none'
      });
      document.getElementById(removeItemId).remove();
      this.RMTStore.createdCollectionItems = removeItem;
      this.RMTStore.createdCollectionId = removeId;
    },
    handleHover (resource) {
      if (!this.RMTStore.displayCollectionItems.includes(resource)) {
        const itemId = '#removeItem' + resource.id;
        gsap.to(itemId, {
          backgroundColor: 'lightgrey',
          duration: .1
        });
      }
    },
    handleHoverLeave (resource) {
      if (!this.RMTStore.displayCollectionItems.includes(resource)) {
        const itemId = '#removeItem' + resource.id;
        gsap.to(itemId, {
          backgroundColor: '#ffffff',
          duration: .1
        });
      }
    },
    handleRemoveItem (item) {
      const itemId = '#item' + item.id;
      const addedItemId = 'addItem' + item.id;
      gsap.to(itemId, {
        border: 'none'
      });
      document.getElementById(addedItemId).remove();
    }
  }
};
</script>

<style scoped>
.collections-item-container {
  cursor: pointer;
}
.marketing-item-container {
  /* width: calc(25% - 4px); */
  height: 200px;
  padding: 2px 2px 10px;
  margin-bottom: 5px;
  margin-left: 2px;
  margin-right: 2px;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  cursor: pointer;
  border: 1px solid white;
  /*  box-shadow: 1px 1px 5px 5px #A6B5A6;*/
}
.image {
	height: 50%;
  width: 50%;
  scale: 2;
  pointer-events: none;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 2px 4px 43px -32px #a6b5a6;
}
.label {
  pointer-events: none;
  padding: 10px 10px 10px 10px;
  font-size: 0.8em;
  font-weight: bold;
}
.label-list {
  white-space: nowrap;
}
.download img {
  width: 100%;
  height: 100%;
}
.marketing-item-list-container {
  width: 100%;
  /* padding: 2px;
  margin-bottom: 5px;
  margin-left: 2px;
  margin-right: 2px; */
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  border: 1px solid #f5f5f5;
}
.left-side {
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.right-side {
  display: flex;
  align-items: center;
  justify-content: center;
}
.selectionMarkerList {
  margin-left: 15px;
  margin-right: 15px;
}
.list-image {
  object-fit: contain;
  height: 55px;
}
.image-list {
  height: 55px;
}
.circle,
.delete {
  cursor: pointer;
  width: 20px;
  height: 20px;
  border-radius: 20px;
  display: flex;
  align-self: flex-end;
  justify-content: flex-end;
}
.icon-size-edit {
  width: 14px;
}
.display-collection-items {
  overflow-y: auto;
  max-height: 700px;
}
.icon-size-del {
  width: 13px;
}
.circle {
  cursor: pointer;
  width: 35px;
  height: 35px;
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>